import { render, staticRenderFns } from "./esports.vue?vue&type=template&id=385174a4&"
import script from "./esports.vue?vue&type=script&lang=js&"
export * from "./esports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports